import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modals from 'modules/Modals';
import Bingo from 'modules/Bingo';
import Button from 'components/Button';

const defaultLockedMessage = 'This bingo room is currently restricted';

const _LockedOverlay = ({ title, lockedMessage, openDeposit, promptDeposit }) => (
  <div className="offline-overlay">
    <div className="offline-overlay__container">
      {title ? <h4>{title}</h4> : null}
      <p>{lockedMessage}</p>
      {promptDeposit ? (
        <Button
          buttonText="Deposit"
          onClick={openDeposit}
          name="openDeposit"
          id="lockedOverlay-openDeposit"
        />
      ) : null}
    </div>
  </div>
);

_LockedOverlay.propTypes = {
  title: PropTypes.string,
  lockedMessage: PropTypes.string,
  promptDeposit: PropTypes.bool,
  openDeposit: PropTypes.func.isRequired
};

_LockedOverlay.defaultProps = {
  title: 'You are not yet eligible to play here',
  lockedMessage: defaultLockedMessage,
  promptDeposit: false
};

const mapStateToProps = (state) => {
  const refName = Bingo.selectors.getActiveRef(state);
  const inPlay = Bingo.selectors.getInPlay(state, refName);
  const inProgress = Bingo.selectors.getInProgress(state, refName);

  return {
    lockedMessage: Bingo.selectors.getLockedMessage(
      state,
      refName,
      inPlay || inProgress ? 'current' : 'next'
    ),
    promptDeposit: Bingo.selectors.getPromptDeposit(
      state,
      refName,
      inPlay || inProgress ? 'current' : 'next'
    )
  };
};

const mapDispatchToProps = (dispatch) => ({
  openDeposit: () => dispatch(Modals.actions.open('deposit'))
});

export default connect(mapStateToProps, mapDispatchToProps)(_LockedOverlay);
